import React from 'react';
import styled from 'styled-components';

// Estilo específico para o código monoespaçado
const CodeSpan = styled.code`
  font-family: 'Courier New', Courier, monospace;
  background-color: rgba(135, 131, 120, 0.15); /* Fundo sutil como no WhatsApp Dark */
  padding: 0.1em 0.3em;
  border-radius: 3px;
  font-size: 0.9em;
`;

// Função para converter o texto com markdown simples para elementos React
const formatWhatsappText = (text) => {
  if (!text) return '';

  // Regex para encontrar os padrões, incluindo quebras de linha dentro deles
  // A ordem é importante: monospace -> bold -> italic -> strikethrough
  const parts = text
    .split(/(```[\s\S]*?```|\*\*.*?\*\*|_.*?_|~.*?~)/g) // Divide pelos padrões
    .map((part, index) => {
      if (part?.startsWith('```') && part?.endsWith('```')) {
        return <CodeSpan key={index}>{part.slice(3, -3)}</CodeSpan>;
      }
      if (part?.startsWith('**') && part?.endsWith('**')) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      if (part?.startsWith('_') && part?.endsWith('_')) {
        // Evitar confundir com underscores internos (ex: session_id)
        // Regex mais simples pode ser suficiente se não houver aninhamento complexo
        if (!part.slice(1, -1).includes('_')) {
           return <em key={index}>{part.slice(1, -1)}</em>;
        }
      }
      if (part?.startsWith('~') && part?.endsWith('~')) {
        return <del key={index}>{part.slice(1, -1)}</del>;
      }
      // Substituir quebras de linha literais por <br />
      // Dividir por \n e juntar com <br />
      const lines = part?.split('\n').map((line, lineIndex, arr) => (
        <React.Fragment key={`${index}-l-${lineIndex}`}>
          {line}
          {lineIndex < arr.length - 1 && <br />}
        </React.Fragment>
      ));
      return <React.Fragment key={index}>{lines}</React.Fragment>;
    });

  return parts;
};


// Componente que usa a função de formatação
export default function FormattedMessage({ content }) {
  return <>{formatWhatsappText(content)}</>;
}
